<template>
  <div id="home">

    <div class="content">
      <div class="queryRow">
        <div class="searchRow">
          <div class="center">
            <el-input v-model="keywords" @change="searchFunction" placeholder="promotion Code, email" class="input"></el-input>
          </div>
          <div class="center">
            <el-select v-model="type" placeholder="Select Type" @change="searchFunction">
              <el-option label="New Client" :value="0"></el-option>
              <el-option label="Discount" :value="1"></el-option>
            </el-select>
          </div>
          <div>
            <el-button type="primary" @click="clear_form" icon="el-icon-refresh" size="small" style="background-color: #034844;border-color:#034844;margin-left:12px;">Reset</el-button>
          </div>
        </div>
        <div class="addBtn">
          <el-button type="primary" @click="show_add" icon="el-icon-plus" size="small" style="background-color: #034844;border-color:#034844;">Add</el-button>
        </div>
      </div>

      <el-table
        v-loading="table_loading"
        :data="tableData"
        :header-cell-style="{ fontSize: '14px', backgroundColor: '#F8F9FA',color:'#4A5468',fontWeight:'normal'}"
        :cell-style="{ fontSize: '14px'}"
        style="width: 100%;">
        <el-table-column
          align="center"
          prop="promotionCode"
          min-width="150px"
          label="Code">
        </el-table-column>

        <el-table-column
          align="center"
          min-width="250px"
          label="Belongs to">
          <template slot-scope="scope">
            <span v-if="scope.row.email">
                {{scope.row.practiceName}}({{scope.row.email}})
            </span>
          </template>
        </el-table-column>

        <el-table-column
          min-width="150px"
          align="center"
          label="Type">
          <template slot-scope="scope">
            {{scope.row.type==0?'New Client':''}}{{scope.row.type==1?'Discount':''}}
          </template>
        </el-table-column>

        <el-table-column
          prop="description"
          align="center"
          min-width="200px"
          label="Description">
        </el-table-column>

        <el-table-column
          align="center"
          min-width="150px"
          label="Detail">
          <template slot-scope="scope">
            {{scope.row.type==0?(scope.row.addTime + ' days'):''}}{{scope.row.type==1?('$' + scope.row.discountMoney):''}}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          min-width="150px"
          label="Valid from">
          <template slot-scope="scope">
            {{moment(scope.row.startTime).format('MM/DD/YYYY')}}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          min-width="200px"
          label="Expired on">
          <template slot-scope="scope">
            {{moment(scope.row.endTime).format('MM/DD/YYYY')}}
          </template>
        </el-table-column>

        <el-table-column
          label="Action"
          min-width="200px"
          align="center">
          <template slot-scope="scope" v-if="scope.row.fullName != 'admin'">
            <el-link type="primary" title="Edit" style="margin-left: 10px;" @click="show_edit(scope.row.id)"><i class="font-size-16 el-icon-edit"></i></el-link>
            <el-link type="primary" title="Delete" style="margin-left: 10px;" @click="removeInfo(scope.row.id)"><i class="font-size-16 el-icon-delete"></i></el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="page_size"
          :total="totalRows">
        </el-pagination>
      </div>
    </div>
    <add ref="addForm" @ok="searchFunction"></add>
    <edit ref="editForm" @ok="searchFunction"></edit>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getAction,deleteAction } from '@/network/manage';
  import moment from 'moment/moment';
  import Add from './promotionCode/add'
  import Edit from './promotionCode/edit'
  export default {
    name: 'PromotionCodeList',
    components: {
      Add,Edit
    },
    data() {
      return {
        keywords:'',
        type: undefined,
        totalRows: 0,
        current_page: 1,
        page_size: 10,
        tableData: [],
        table_loading: false
      }
    },
    computed: {

    },
    mounted() {

    },
    created(){
      this.getDatas(1)
    },
    methods:{
      show_add() {
        this.$refs.addForm.init()
      },
      show_edit(id) {
        this.$refs.editForm.init(id)
      },
      moment,
      clear_form(){
        this.keywords = ""
        this.type = undefined
        this.getDatas(1)
      },
      show(id) {
        this.$refs.showForm.init(id)
      },
      removeInfo(id){
        const that = this
        this.$confirm('Do you really want to delete this data?', 'confirm', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning',
          center: true
        }).then(() => {
          that.table_loading = true
          deleteAction("/admin/promotion/delete?id="+id).then((res) => {
            if(res.success){
              that.$message({
                type: 'success',
                message: 'delete success!'
              });
              that.searchFunction()
            }else{
              that.$message.error(res.message);
            }
          }).catch((err) => {

          }).finally((res) => {
            that.table_loading = false
          })

        })
      },
      show_edit(id) {
        this.$refs.editForm.init(id)
      },
      show_expired(id,expiredDate){
        this.$refs.expriedForm.init(id,expiredDate)
      },
      show_reset(id) {
        this.$refs.resetForm.init(id)
      },
      searchFunction(){
        this.getDatas(1)
      },
      getDatas(initSize) {
        if(initSize == 1) {
          this.current_page = 1
        } else {
          this.current_page = initSize
        }
        this.table_loading = true
        let param = {keywords:this.keywords, type: this.type};
        getAction("/admin/promotion/list?pageSize=" + this.page_size + "&pageNo=" + this.current_page,param).then((res) => {
          if(res.success){
            this.tableData = res.result.records
            this.totalRows = res.result.total
          }else{
            this.$message.error(res.message);
          }
        }).catch((err) => {

        }).finally((res) => {
          this.table_loading = false
        })
      },
      handleCurrentChange(val) {
        this.getDatas(val)
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;}
  #home{background-color:#E6ECEB;padding:20px;min-height: calc(100vh - 70px);}
  .content{background-color: #ffffff;padding: 30px;display: grid;gap: 20px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);border-radius: 16px;}
  .flex{display: flex;justify-content: flex-end;width: 400px;}
  .pager{display: flex;justify-content: center;}
  .font-size-16 {font-size: 18px;color:#000000;}
  .input{width: 300px;}
  .queryRow{display: flex;justify-content: space-between;align-items: center;}
  .searchRow{display: flex;justify-content: flex-start;align-items: center;flex-wrap: wrap;}
  .queryRow div:nth-child(2){margin-left:10px;}
  @media (max-width: 768px) {
    #home{padding:0;background-color:#ffffff;}
    .content{padding:20px 20px;border-radius: 0px;box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);}
    .flex{width: 100%;}
    .input{width: 100%;}
    .queryRow{flex-direction: column;}
    .queryRow div:nth-child(2){margin-top:10px;margin-left:0;}
    .queryRow div:nth-child(3){margin-top:10px;margin-left:0;}
    .addBtn{align-self: flex-start;margin-top:10px;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {

  }
</style>
